var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "insert-rec insert-list" }, [
    _c("p", { staticClass: "insert-list__title" }, [
      _vm._v(_vm._s(_vm.cardInfo.title)),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "insert-list__ul" },
      [
        _vm._l(_vm.cardInfo.list, function (item, index) {
          return [
            item.title
              ? _c("li", { key: index, staticClass: "insert-list__li" }, [
                  _c("i", { staticClass: "dot" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: item.url,
                        target: "_blank",
                        "data-spm-data": _vm.cardInfo.spm + "-" + (index + 1),
                      },
                    },
                    [
                      item.type === 3
                        ? _c("span", { staticClass: "atlas-font" }, [
                            _vm._v("图集"),
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.title) +
                          "\n                "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }